import { LeftMenu } from './components/LeftMenu';
import AIModelPreference from './components/AIModelPreference';
import { GENERATOR } from '../settings';

/**
 * Generator's contribution to the app shell. Discovered automatically by
 * common/shell/registry.js — MenuLeft renders this without importing generator.
 */
export const sidebar = [
  {
    id: 'generator',
    order: 20,
    enabled: () => GENERATOR,
    Component: LeftMenu,
  },
];

/**
 * Account → Preferences: which LLM the user's AI calls default to. Model choice
 * is a generator concern, so the user module renders it through the slot rather
 * than importing it.
 */
export const accountSections = [
  {
    id: 'generator-ai-model',
    order: 20,
    enabled: () => GENERATOR,
    Component: AIModelPreference,
  },
];

/**
 * Where a freshly authenticated session lands. The generator owns the app the
 * user actually came for, so it claims the landing page; the user module falls
 * back to /home when the generator is not deployed.
 */
export const landingRoutes = [
  {
    id: 'generator',
    order: 20,
    enabled: () => GENERATOR,
    path: '/generator/application',
  },
];

/**
 * The page documenting the token-authenticated API. Personal Access Tokens are
 * minted in Account → API access, but what they unlock — the agent lane — is
 * documented by the generator, so it publishes the link.
 */
export const tokenDocs = [
  {
    id: 'generator',
    order: 20,
    enabled: () => GENERATOR,
    path: '/generator/docs',
  },
];
